/* Alert */
export const SHOW_ALERT_MSG = 'SHOW_ALERT_MSG';
export const HIDE_ALERT_MSG = 'HIDE_ALERT_MSG';

/* User Info */
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const LOGOUT_USER = 'LOGOUT_USER';
export const USER_INFO_SUCCESS = 'USER_INFO_SUCCESS';

/* RANGE FORCASTING FORM */
export const RANGE_FORCASTING_DATA = 'RANGE_FORCASTING_DATA';
export const GET_SIMULATION = 'GET_SIMULATION';
export const GET_FMU= 'GET_FMU';
export const GET_FCMT= 'GET_FCMT';